// extracted by mini-css-extract-plugin
module.exports = {"exportBox":"studio_exportBox__Lj_5c"};